<!--五馆-预约专属研学-研学活动列表（参考用户端 excursionPage）-->
<template>
    <div class="ex-list-container">
        <div class="ex-museum-title-container">
            <div class="ex-l-title">
                <div class="ex-l-t-title">预约专属研学</div>
                <div class="ex-l-b-title">沉浸研学 一键预约</div>
            </div>
            <div class="ex-r-title">
                <div class="ex-search-box">
                    <input class="ex-search-input" type="text" placeholder="请输入关键词"
                           v-model="queryParams.excursionTitle" @keyup.enter="handleSearch" />
                </div>
                <div class="ex-back-btn" @click="backPage">⇦返回</div>
            </div>
        </div>

        <!-- 研学营切换 -->
        <div class="ex-tabs">
            <div class="ex-tab-item" v-for="item in campList" :key="item.dictKey"
                 :class="{ active: queryParams.campKey === item.dictKey }"
                 @click="changeCamp(item.dictKey)">{{ item.dictValue }}</div>
        </div>

        <!-- 研学活动列表 -->
        <div class="ex-camp-list" v-loading="loading">
            <div class="ex-camp-card" v-for="item in dataList" :key="item.excursionId" @click="handleDetail(item)">
                <div class="ex-camp-cover">
                    <img class="img-100" :src="item.excursionCover || defaultCover" :alt="item.excursionTitle" />
                </div>
                <div class="ex-camp-info">
                    <div class="ex-camp-title" :title="item.excursionTitle">{{ item.excursionTitle }}</div>
                    <div class="ex-camp-subtitle" :title="item.excursionSubtitle">{{ item.excursionSubtitle }}</div>
                    <div class="ex-camp-tags">
                        <div class="ex-camp-tag">类型：{{ campName(item.campKey) }}</div>
                        <div class="ex-camp-tag" :title="item.excursionTheme">主题：{{ item.excursionTheme }}</div>
                        <div class="ex-camp-tag">活动时间：{{ formatTimeRange(item) }}</div>
                    </div>
                </div>
                <div class="ex-camp-detail-btn" @click.stop="handleDetail(item)">查看详细行程</div>
            </div>
            <div class="ex-empty-box" v-if="!loading && dataList.length === 0">
                <dataEmpty title="暂无数据"/>
            </div>
        </div>

        <!-- 分页 -->
        <div class="ex-pagination-box" v-if="total > 0">
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
        </div>
    </div>
</template>

<script>
import { pageExcursion, queryDict } from "@/api/admin/museum";
import { timestampDate } from "@/utils/date";
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "excursionList",
    components: { dataEmpty },
    data() {
        return {
            loading: false,
            total: 0,
            dataList: [],
            campList: [],
            queryParams: {
                excursionTitle: '',
                campKey: '',
                pageNum: 1,
                pageSize: 10,
            },
            defaultCover: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
        }
    },
    props: {
        markInfo: {
            type: String,
            default: null
        },
        /* 当前馆默认选中的研学营 */
        campKey: {
            type: [String, Number],
            default: ''
        },
    },
    watch: {
        markInfo() {
            this.queryParams.excursionTitle = '';
            this.queryParams.campKey = '';
            this.queryParams.pageNum = 1;
            this.handleQueryDict();
        },
    },
    created() {
        this.handleQueryDict();
    },
    methods: {
        /* ===============字典查询===================== */
        handleQueryDict() {
            queryDict({ code: 'museum_camp' }).then(res => {
                if (res.data.code === 1) {
                    this.campList = res.data.data || [];
                    // 未指定研学营时默认选中当前馆对应的营，无对应营则选中第一个
                    if (this.campList.length > 0 && !this.queryParams.campKey) {
                        const matched = this.campList.find(item => String(item.dictKey) === String(this.campKey));
                        this.queryParams.campKey = matched ? matched.dictKey : this.campList[0].dictKey;
                    }
                }
                this.pageList();
            });
        },

        /* ===============分页查询===================== */
        pageList(e) {
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageExcursion(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total || 0;
                    this.dataList = res.data.data.list || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============筛选与搜索===================== */
        changeCamp(campKey) {
            if (this.queryParams.campKey === campKey) return;
            this.queryParams.campKey = campKey;
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleSearch() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },

        /* ===============工具方法===================== */
        campName(campKey) {
            const camp = this.campList.find(item => item.dictKey === campKey);
            return camp ? camp.dictValue : (campKey || '--');
        },
        formatTimeRange(item) {
            const begin = item.beginTime ? timestampDate(Number(item.beginTime)) : '';
            const end = item.endTime ? timestampDate(Number(item.endTime)) : '';
            if (begin && end) return begin + '至' + end;
            return begin || end || '--';
        },

        /* ===============跳转===================== */
        backPage() {
            this.$emit('back-page');
        },
        handleDetail(item) {
            this.$emit('view-info', item);
        },
    }
}
</script>

<style scoped>
.ex-list-container {
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.ex-museum-title-container {
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 10px;
    margin-bottom: 14px;
}

.ex-l-title {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.ex-l-t-title {
    font-weight: bold;
    color: #ff7f2e;
    font-size: 18px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ex-l-b-title {
    color: #9a9a9a;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ex-r-title {
    flex-shrink: 0;
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 12px;
}

.ex-search-box {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ex-search-input {
    width: 200px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
    box-sizing: border-box;
    background-color: #ffffff;
}

.ex-search-input:focus {
    border-color: #ff7f2e;
}

.ex-search-btn {
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    border: 1px solid #ff7f2e;
    border-radius: 6px;
    font-size: 14px;
    color: #ff7f2e;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.ex-search-btn:hover {
    background-color: #ff7f2e;
    color: #ffffff;
}

.ex-back-btn {
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

/* 研学营切换 */
.ex-tabs {
    flex-shrink: 0;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
}

.ex-tab-item {
    min-width: 110px;
    height: 34px;
    line-height: 32px;
    padding: 0 20px;
    text-align: center;
    border: 1px solid #ff7f2e;
    border-radius: 6px;
    font-size: 14px;
    color: #ff7f2e;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.ex-tab-item:hover {
    background-color: #fff5ee;
}

.ex-tab-item.active {
    background-color: #ff7f2e;
    color: #ffffff;
    border-color: #ff7f2e;
}

/* 研学活动列表 */
.ex-camp-list {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 4px 4px 10px 4px;
}

.ex-camp-list::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.ex-camp-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.ex-camp-list::-webkit-scrollbar-thumb {
    background: #ff7f2e;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.ex-camp-card {
    width: 100%;
    height: 150px;
    display: flex;
    align-items: stretch;
    background-color: #ffffff;
    border: 1.5px solid #ff7f2e;
    border-radius: 6px;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.25s ease;
    flex-shrink: 0;
}

.ex-camp-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.ex-camp-cover {
    width: 220px;
    flex-shrink: 0;
    background-color: #f3f4f6;
    overflow: hidden;
}

.ex-camp-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.ex-camp-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
    box-sizing: border-box;
}

.ex-camp-title {
    width: 100%;
    font-size: 17px;
    font-weight: bold;
    color: #1f2937;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ex-camp-subtitle {
    width: 100%;
    font-size: 14px;
    color: #6b7280;
    margin-top: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ex-camp-tags {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: auto;
    padding-top: 12px;
}

.ex-camp-tag {
    max-width: 320px;
    padding: 4px 12px;
    background-color: #f3f4f6;
    border-radius: 2px;
    font-size: 13px;
    color: #4b5563;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}

.ex-camp-detail-btn {
    align-self: center;
    flex-shrink: 0;
    margin: 0 24px;
    height: 34px;
    line-height: 32px;
    padding: 0 18px;
    border: 1px solid #ff7f2e;
    border-radius: 6px;
    font-size: 14px;
    color: #ff7f2e;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.ex-camp-detail-btn:hover {
    background-color: #ff7f2e;
    color: #ffffff;
}

.ex-empty-box {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

/* 分页 */
.ex-pagination-box {
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    box-sizing: border-box;
}

/* Pagination 组件内置了 position:absolute;right:0 的内联样式，覆盖为正常文档流以实现居中 */
.ex-pagination-box :deep(.el-pagination) {
    position: static !important;
}
</style>
